/**
 * @file Processor
 * @author Wim Haanstra
 */
import * as moment from 'moment';
var DetailLevel = /** @class */ (function () {
    /**
     * Convenience constructor
     */
    function DetailLevel(name, title, startOf, rounding, duration, step, formatter) {
        /** The steps it needs to take on a next or previous */
        this.step = 1;
        this._formatter = null;
        this.name = name;
        this.title = title;
        this.startOf = startOf;
        this.duration = duration;
        this.step = step;
        this.rounding = rounding;
        this.barFormatter = formatter;
    }
    Object.defineProperty(DetailLevel.prototype, "formatter", {
        get: function () {
            if (this._formatter == null) {
                this._formatter = (new this.barFormatter());
            }
            return this._formatter;
        },
        enumerable: true,
        configurable: true
    });
    DetailLevel.prototype.startForDate = function (date) {
        return moment(date).startOf(this.startOf).startOf(this.rounding);
    };
    DetailLevel.prototype.endForDate = function (date) {
        return moment(date).endOf(this.startOf).endOf(this.rounding);
    };
    return DetailLevel;
}());
export { DetailLevel };
